// extracted by mini-css-extract-plugin
module.exports = {"head":"app-layout_head__3DsjL","content":"app-layout_content__2D45m","foot":"app-layout_foot__3cD0v"};